import React, { useMemo } from 'react';

import { IExercise } from '../../../../../../domains/Exercise';
import {
  Bar,
  Container,
  Empty,
  Level,
  Row,
  RowHeader,
  Title,
  Track,
} from './styles';

interface VolumeAnalysisProps {
  exercises: IExercise[];
}

const VolumeAnalysis: React.FC<VolumeAnalysisProps> = ({ exercises }) => {
  const groups = useMemo(() => {
    const counts = new Map<string, number>();

    exercises.forEach(exercise => {
      const main =
        exercise.muscle_groups.find(group => group.is_main) ||
        exercise.muscle_groups[0];

      const name = main?.muscle_group?.name || main?.name;

      if (name) {
        counts.set(name, (counts.get(name) || 0) + 1);
      }
    });

    const max = Math.max(1, ...Array.from(counts.values()));

    const getLevel = (percent: number) => {
      if (percent >= 70) return 'Alto';
      if (percent >= 35) return 'Moderado';
      return 'Baixo';
    };

    return Array.from(counts.entries())
      .map(([name, count]) => {
        const percent = (count / max) * 100;

        return {
          name,
          count,
          percent,
          level: getLevel(percent),
        };
      })
      .sort((a, b) => b.count - a.count);
  }, [exercises]);

  return (
    <Container>
      <Title>Volume por grupo muscular</Title>

      {!groups.length && <Empty>Sem exercícios cadastrados para o dia.</Empty>}

      {groups.map(group => {
        const high = group.level === 'Alto';

        return (
          <Row key={group.name}>
            <RowHeader>
              <span>{group.name}</span>
              <Level high={high}>{group.level}</Level>
            </RowHeader>
            <Track>
              <Bar percent={group.percent} high={high} />
            </Track>
          </Row>
        );
      })}
    </Container>
  );
};

export { VolumeAnalysis };
